// removed by extract-text-webpack-plugin
module.exports = {"block":"_3ow7NV22isN-4Cp0wSvegE","tabs-sticky":"TifgaqTzjHD1GD-3o4Qez","tabs-scroll-container":"_2q3cORPQlTQK3-MPEEUaLk","tabs-container":"_3V7wms7EQEI_uO-XRDW9Cu","tabs":"_1opu2aEqpMFR-gzn6KKWS","tab":"_32tmYizBhvMeWASahn_jRn","no-results":"_3Aqm12q-aT1zzGxBvqOEBH","tab-button":"_1Wpxr_sJZUdhh7_wn21wog","active":"nxKXI7zWEkKVo-1syOKFe","grayed-out":"_1827FTe99eObrC_j9kOGU4","search":"_25s3peS61j4HKygBN0spWH","search-form":"_3QAfxsCMMHHQghZsTtsvbN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyList/CompanyList.module.scss
// module id = 264
// module chunks = 0